import { useRef, useEffect } from "react";
import { useRefObserver } from "./useRefObserver.js";
const useResizeObserver = (ref, onResize) => {
  const observer = useRef(null);
  useRefObserver({
    targetRef: ref,
    cb: (node) => {
      if (node !== null) {
        if (observer.current) {
          observer.current.disconnect();
        }
        observer.current = new ResizeObserver(() => {
          onResize(node);
        });
        observer.current.observe(node);
      } else if (observer.current) {
        observer.current.disconnect();
      }
    }
  });
  useEffect(() => {
    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
      observer.current = null;
    };
  }, []);
};
export {
  useResizeObserver
};
